import {
    FETCH_START,
    FETCH_END,
    GET_ROYALTY_CONTRACT_SUCCESS,
} from './ActionTypes';
import axios from '../../../axios.conf';
import { toast as globalToast } from '../../../components/ToastManager';
import secureLocalStorage from 'react-secure-storage';
import { handleExecutionLog } from '../../../components/ExecutionLogHandler';

export const fetchStart = () => {
    return {
        type: FETCH_START,
    };
};

export const fetchEnd = () => {
    return {
        type: FETCH_END,
    };
};

export const createRoyaltyContracts = (data, id, type) => {
    return async (dispatch) => {
        dispatch(fetchStart());

        try {
            const response = await createRoyaltyContractsAPI(data, id, type);
            dispatch(fetchEnd());

            const logNumber = response?.data?.log_number;

            if (logNumber) {
                const { hasError } = await handleExecutionLog(dispatch, logNumber);

                return { success: !hasError, response };
            } else {
                globalToast.showSuccess(
                    response?.data?.message || response?.data?.response
                );
                return { success: true, response };
            }

        } catch (error) {
            dispatch(fetchEnd());
        }
    };
};
const createRoyaltyContractsAPI = (data, id, type) => {
    const headers = {
        Authorization: secureLocalStorage.getItem('aTk'),
    };
    var result;
    if (type == 'edit') {
        result = axios.put('royalty/contract', {
            ...data,
        }, { headers });

    } else if (type == 'delete') {
        result = axios.delete(`/royalty/contract/${id}`, { headers });

    } else {
        result = axios.post('/royalty/contract', data, { headers });
    }
    return result;
};
export const getRoyaltyContract = (id, type, params) => {
    return (dispatch) => {
        dispatch(fetchStart());
        return getRoyaltyContractAPI(id, type, params)
            .then((response) => {
                dispatch(fetchEnd());
                const raw = response.data;
                const contract = raw?.response ?? raw;
                dispatch(
                    getRoyaltyContractSuccess(contract, id, type),
                );
            })
            .catch((error) => {
                dispatch(fetchEnd());
            });
    };
};

const getRoyaltyContractAPI = (id, type, params) => {
    const headers = {
        Authorization: secureLocalStorage.getItem('aTk'),
    };
    return axios.get(
        `/royalty/contract/${id}`,
        { headers, ...(params ? { params } : {}) }
    );
};
export const getRoyaltyContractSuccess = (data, id, type) => {
    return {
        type: GET_ROYALTY_CONTRACT_SUCCESS,
        data,
    };
};